import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 64 64",
  style: {"background-color":"#ffffff00"},
  xmlns: "http://www.w3.org/2000/svg",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<path d=\"M8 5h48v20H8V5zm0 34h48v22H8V39z\" fill=\"#55acba\"></path><path d=\"M11 51.5h42V58H11v-6.5zm0-10h42V48H11v-6.5zM11 17h42v5H11v-5zm0-9h42v5H11V8z\" stroke=\"#fff\" stroke-width=\"2\" fill=\"#86bc4d\"></path><path d=\"M39 40v20M24 40v20\" stroke=\"#1e3951\" stroke-width=\"2\" fill=\"none\"></path><path d=\"M41 52v6m-15-6v6M41 52v6m-15-6v6M41 42v6m-15-6v6M37 52v6m-15-6v6M37 42v6m-15-6v6\" stroke=\"#fff\" stroke-width=\"2\" fill=\"none\"></path><path d=\"M26.954 26.5l-.017 3.53-8.093.032L31.5 40.5l13.938-10.28-9.393.01V26.5h-9.09z\" stroke=\"#fff\" stroke-width=\"2\" fill=\"#55acba\"></path>", 5)
  ])))
}
export default { render: render }